export default __webpack_public_path__ + "static/media/failMsg.f4bf530b.svg";